import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_NON_NATIONAL_EXAM_SCHOOLING_DETAIL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';
import { SchoolFormDataRequest, SiblingFormData } from '../../models';
import { IOptionType } from '../../api/candidate/exam/model';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface CaeCertificateDetailsModelProps {
  ceqTypeUuid: string;
  centreRefNo: string;
  verificationNo: string;
  country: IOptionType;
  dateTaken: string;
  overallScore: string;
  readingScore: string;
  writingScore: string;
  listeningScore: string;
  speakingScore: string;
}

export interface PostNonNationalExamSchoolingDetailResponse {}

export interface PostNonNationalExamSchoolingDetailRequest {
  caeCertificateDetailsModel: CaeCertificateDetailsModelProps | null;
  schoolInfo: boolean;
  examSchoolInfoModels: SchoolFormDataRequest[];
  siblingInfo: boolean;
  examSiblingInfoModels: SiblingFormData[];
  selectedAdmissionLevel?: string;
  motherTongueLanguageToBeTaken?: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: PostNonNationalExamSchoolingDetailResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostNonNationalExamSchoolingDetail = ({ uuid, onSuccess, onError }: Input) => {
  const usePostExamSchoolingDetail = async (payload: PostNonNationalExamSchoolingDetailRequest) => {
    const res = await axiosClient.post<PostNonNationalExamSchoolingDetailResponse>(
      POST_NON_NATIONAL_EXAM_SCHOOLING_DETAIL(uuid),
      payload
    );
    return res.data;
  };

  return useCustomMutation(
    usePostExamSchoolingDetail,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
